import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
  },
  state: {
    live_news: [
      {
        id    : 1,
        date  : 1543093200000,
        author: {
          id    : 1,
          name  : 'OlegAfanasiev',
          avatar: '/images/avt-40-1.png',
        },
        text: 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для регистрации на портале необходимо запросить логин/пароль у своего…',
      },
    ],
    selected_number: 10,
    selected_page  : 1,
    search_string  : '',
  },
  getters: {
    live_news       : ({live_news}) => live_news,
    selected_number : ({selected_number}) => selected_number,
    selected_page   : ({selected_page}) => selected_page,
    search_string   : ({search_string}) => search_string,
    search_by_string: ({search_string, live_news=[]})=> {
      if (search_string) {
        return live_news.filter((x)=> x.message.toLowerCase().includes(search_string.toLowerCase()));
      } else return live_news;
    },
    paginated({search_string}, {selected_number, live_news, selected_page, search_by_string}) {
      let search_filtered = search_string ? search_by_string : live_news;
      return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
    },
  },
  mutations: {
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
      state.selected_page = 1;
    },
    SET_LIVE_NEWS(state, value) {
      state.live_news = value;
    },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {live_news} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: live_news, selected: event});
    },
    async get_live_news({commit}) {
      try {
        const live_news = await api.live_news.get_live_news();
        commit('SET_LIVE_NEWS', live_news.data.items);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
